export default "/images/vendor/@coreui/icons/svg/flag/cif-np.svg?4609a45e40d668aa31835f4c2dcff880";